import React from 'react';

// eslint-disable-next-line react/prop-types
const Controls = ({ children }) => {
  return <div>{children}</div>;
};

export default Controls;
